"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeGetShouldDisabledOrderButton = exports.makeGetReasonOfDisabledOrderButton = void 0;
var _ramda = require("ramda");
var _selectors = require("@otpusk/apisearch-toolbox/dist/offers/selectors");
var _localization = _interopRequireDefault(require("../../../../../../../../../localization"));
var _selectors2 = require("../../../../BookingServices/store/selectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var makeGetShouldDisabledOrderButton = exports.makeGetShouldDisabledOrderButton = function makeGetShouldDisabledOrderButton(offerID) {
  return (0, _ramda.converge)(function (isNotFound, isStopSale, shouldRecalculatePrice) {
    return isNotFound || isStopSale || shouldRecalculatePrice;
  }, [(0, _ramda.partialRight)((0, _selectors.isNotFoundActualizedOffer)(), [{
    offerID: offerID
  }]), (0, _ramda.partialRight)((0, _selectors.getIsStopSaleByHotel)(), [{
    offerID: offerID
  }]), _selectors2.getShouldRecalculatePrice]);
};
var makeGetReasonOfDisabledOrderButton = exports.makeGetReasonOfDisabledOrderButton = function makeGetReasonOfDisabledOrderButton(offerID) {
  return (0, _ramda.converge)(function (isNotFound, isStopSale, shouldRecalculatePrice) {
    switch (true) {
      case isNotFound || isStopSale:
        {
          return _localization.default.t('OFFER_DETAILS:DISABLED_ORDER_BUTTON_HINT');
        }
      case shouldRecalculatePrice:
        {
          return _localization.default.t('OFFER_DETAILS:DISABLED_ORDER_BUTTON_HINT_OF_RECALCULATED_OFFER');
        }
      default:
        return undefined;
    }
  }, [(0, _ramda.partialRight)((0, _selectors.isNotFoundActualizedOffer)(), [{
    offerID: offerID
  }]), (0, _ramda.partialRight)((0, _selectors.getIsStopSaleByHotel)(), [{
    offerID: offerID
  }]), _selectors2.getShouldRecalculatePrice]);
};